import useStaticData from './useStaticData'
import queryString from 'query-string'

const params = window.location.search ? queryString.parse(window.location.search) : {}

export const getDowelingResults = (input, staticData) => {
  const {
    adhesiveAnchor,
    insertType,
    insertDiameter,
    drillBitDiameter,
    embedmentDepth,
    screenTube,
    numberInstallations,
    overageFactor,
    waterFilledHoles,
  } = input
  const { getModels, getApitchOrArebar, getDrillBitDiameterOptions } = useStaticData(staticData)

  const models = getModels(adhesiveAnchor)
  const aPitchOrArebar = getApitchOrArebar(insertDiameter, insertType)
  const conversionFactor = 1.805
  const drillBitDiameterList = getDrillBitDiameterOptions(adhesiveAnchor, insertType, insertDiameter)

  // Convert drillBitDiameter value from Millimeters to Inches
  const drillBitDiameterItem = drillBitDiameterList.find(item => item.value === drillBitDiameter && item.text.includes("MM"))
  const updateDrillBitDiameter = drillBitDiameterItem  ? (drillBitDiameterItem.value / 25.4) : drillBitDiameter

  const calculationResults = models.map((item) => {
    const usableCartridgeVolume = (
      item.cartridgeVolume *
      item.usableCartridgeVolumePercentage *
      conversionFactor
    ).toFixed(4)
    if (embedmentDepth && !screenTube) {
      let volumeCalculation = (
        (3.14159 / 4) *
        updateDrillBitDiameter *
        updateDrillBitDiameter *
        embedmentDepth
      ).toFixed(4)
      // for all SET-XP, AT-XP, ET-HP, waterFilledHoles is null
      // for SET-3G, waterFilledHoles is either true or false
      if (!waterFilledHoles || waterFilledHoles === false) {
        volumeCalculation = (volumeCalculation - aPitchOrArebar * embedmentDepth).toFixed(4)
      }
      const totalVolume = (volumeCalculation * numberInstallations).toFixed(4)
      const cartridgesNeeded = (
        (totalVolume / usableCartridgeVolume) *
        (parseFloat(overageFactor) + 1.0)
      ).toFixed(3)
      const aValue =
        insertType === 'Threaded Rod' ? { aPitch: aPitchOrArebar } : { aRebar: aPitchOrArebar }
      return Object.assign(
        {},
        {
          model: item.model,
          cartridgeVolume: item.cartridgeVolume,
          usableCartridgeVolumePercentage: item.usableCartridgeVolumePercentage,
          usableCartridgeVolume: usableCartridgeVolume,
          volumeCalculation: volumeCalculation,
          totalVolume: totalVolume,
          cartridgesNeeded: parseFloat(cartridgesNeeded),
        },
        aValue,
      )
    } else {
      // const screenTubeValues = screenTube.split('_') // [screenTubeModel, depth, internalDiameter]
      // const volumeCalculation = (3.14159 / 4 * screenTubeValues[2] * screenTubeValues[2] * screenTubeValues[1]).toFixed(4)

      const screenTubeBaseModel = screenTube.includes('3GWS')
        ? screenTube.substring(0, 6)
        : screenTube.substring(0, 5) // EWS758P ==> EWS75, ETS7513 ==> ETS75
      let screenTubeDepth = screenTube.includes('3GWS')
        ? screenTube.substring(6).replace('P', '')
        : screenTube.substring(5).replace('P', '') // EWS373P ==> 3.5, EWS758P ==> 8, ETS7513  ==> 13
      screenTubeDepth = screenTubeDepth === '3' ? 3.5 : parseFloat(screenTubeDepth)
      const screenTubeInteriorDiameter =
        staticData.screenTubeInteriorDiameterInfo[screenTubeBaseModel] // EWS758P ==> 0.855,  ETS7513 ==> 0.918

      const volumeCalculation = (
        (3.14159 / 4) *
        screenTubeInteriorDiameter *
        screenTubeInteriorDiameter *
        screenTubeDepth
      ).toFixed(4)

      // console.log('---', screenTube, screenTubeBaseModel, screenTubeDepth, screenTubeInteriorDiameter, volumeCalculation)

      const totalVolume = (volumeCalculation * numberInstallations).toFixed(4)
      const cartridgesNeeded = (
        (totalVolume / usableCartridgeVolume) *
        (parseFloat(overageFactor) + 1.0)
      ).toFixed(3)

      return {
        model: item.model,
        cartridgeVolume: item.cartridgeVolume,
        usableCartridgeVolumePercentage: item.usableCartridgeVolumePercentage,
        usableCartridgeVolume: usableCartridgeVolume,
        screenTubeInteriorDiameter: screenTubeInteriorDiameter,
        screenTubeDepth: screenTubeDepth,
        volumeCalculation: volumeCalculation,
        totalVolume: totalVolume,
        cartridgesNeeded: parseFloat(cartridgesNeeded),
      }
    }
  })

  return calculationResults
}

// convert list of object to key-value object, key is the model
export const getJobModel = (list) => {
  const jobModelObj = list.reduce((result, item) => {
    result[item.model] = item.cartridgesNeeded
    return result
  }, {})

  return jobModelObj
}

export const formatInputJobList = (list) => {
  return list.reduce((result, item) => {
    result.push({
      jobName: item.jobName,
      userInputs: item.userInputs,
    })
    return result
  }, [])
}

const getInjectionResinResults = (input, injectionResinModels) => {
  const { crackWidth, crackDepth, crackLength, overageFactor } = input

  return injectionResinModels.map((item, index) => {
    // item.cartridgeVolume is in ounce(oz)
    const cartridgeVolumeInGallon = item.cartridgeVolume / 128
    const cartridgeVolumeInCubicInches = item.cartridgeVolume * 1.805
    const usableCartridgeVolumeInCubicInches =
      cartridgeVolumeInCubicInches * item.usableCartridgeVolumePercentage
    const volumeCalculationInCubicInches = (crackWidth * crackDepth * (crackLength * 12)).toFixed(4)
    const cartridgesNeeded = (
      (volumeCalculationInCubicInches / usableCartridgeVolumeInCubicInches) *
      (parseFloat(overageFactor) + 1.0)
    ).toFixed(3)

    return Object.assign(
      {},
      {
        model: item.model,
        overageFactor: overageFactor,
        productUrl: params && params.source && params.source === 'EC' ? `${params.sourceDomain}/${item.productUrlEC}` : item.productUrl,
        packagingType: item.packagingType,
        cartridgeVolume: item.cartridgeVolume,
        cartridgeVolumeInGallon: cartridgeVolumeInGallon,
        cartridgeVolumeInCubicInches: cartridgeVolumeInCubicInches,
        usableCartridgeVolumePercentage: item.usableCartridgeVolumePercentage,
        usableCartridgeVolumeInCubicInches: usableCartridgeVolumeInCubicInches,
        volumeCalculationInCubicInches: volumeCalculationInCubicInches,
        cartridgesNeeded: parseFloat(cartridgesNeeded),
      },
    )
  })
}

const getPasteOverEpoxyResults = (input, pasteOverEpoxyModels) => {
  const {
    pasteOverBothSidesOfCrack,
    crackLength,
    overageFactor,
    pumpingPortStyle,
    pumpingPortSpacing,
  } = input

  return pasteOverEpoxyModels.map((item, index) => {
    const cartridgeVolumeInGallon = item.cartridgeVolume / 128
    const cartridgeVolumeInCubicInches = item.cartridgeVolume * 1.805

    const usableCartridgeVolumeInCubicInches = (
      cartridgeVolumeInCubicInches * item.usableCartridgeVolumePercentage
    ).toFixed(4)

    const crackLengthInCubicInches = pasteOverBothSidesOfCrack
      ? crackLength * 2.25 * 2
      : crackLength * 2.25

    let volumeCalculationInCubicInches = 0.0
    if (pumpingPortStyle === 'Flush Mount') {
      volumeCalculationInCubicInches = (
        crackLengthInCubicInches +
        ((crackLength * 12) / pumpingPortSpacing) * 1.653
      ).toFixed(4)
    } else {
      volumeCalculationInCubicInches = crackLengthInCubicInches.toFixed(4) // ACE-191, ACE-195
    }
    const cartridgesNeeded = (
      (volumeCalculationInCubicInches / usableCartridgeVolumeInCubicInches) *
      (parseFloat(overageFactor) + 1.0)
    ).toFixed(3)

    return {
      model: item.model,
      overageFactor: overageFactor,
      productUrl: params && params.source && params.source === 'EC' ? `${params.sourceDomain}/${item.productUrlEC}` : item.productUrl,
      cartridgeVolume: item.cartridgeVolume,
      cartridgeVolumeInGallon: cartridgeVolumeInGallon,
      cartridgeVolumeInCubicInches: cartridgeVolumeInCubicInches,
      usableCartridgeVolumePercentage: item.usableCartridgeVolumePercentage,
      usableCartridgeVolumeInCubicInches: usableCartridgeVolumeInCubicInches,
      volumeCalculationInCubicInches: volumeCalculationInCubicInches,
      cartridgesNeeded: parseFloat(cartridgesNeeded),
    }
  })
}

const getPumpingPortsResults = (input, pumpingPortsModels) => {
  const { crackLength, pumpingPortStyle, pumpingPortSpacing } = input

  return pumpingPortsModels.map((item, index) => {
    const packagesNeeded = ((crackLength * 12) / pumpingPortSpacing / item.packageSize).toFixed(3)
    return {
      model: item.model,
      productUrl: params && params.source && params.source === 'EC' ? `${params.sourceDomain}/${item.productUrlEC}` : item.productUrl,
      packageSize: item.packageSize,
      pumpingPortStyle: pumpingPortStyle,
      packagesNeeded: parseFloat(packagesNeeded),
      // description: item.description,
    }
  })
}

const getInjectionFittingsResults = (input, injectionFittingsModels) => {
  const { pasteOverEpoxy } = input

  return injectionFittingsModels.map((item, index) => {
    const packagesNeeded = pasteOverEpoxy !== 'none' ? 1 : 0

    return {
      model: item.model,
      productUrl: params && params.source && params.source === 'EC' ? `${params.sourceDomain}/${item.productUrlEC}` : item.productUrl,
      packageSize: item.packageSize,
      packagesNeeded: parseFloat(packagesNeeded),
      // description: item.description,
    }
  })
}

export const getCrackInjectionResults = (input, staticData) => {
  const { injectionResin, pasteOverEpoxy, pumpingPortStyle } = input
  const { getCrackInjectionModels } = useStaticData(staticData)

  const injectionResinModels = getCrackInjectionModels(injectionResin)
  const pasteOverEpoxyModels =
    pasteOverEpoxy !== 'none' ? getCrackInjectionModels(pasteOverEpoxy) : []
  const pumpingPortStyleModels =
    pasteOverEpoxy !== 'none' ? getCrackInjectionModels(pumpingPortStyle) : []
  const { pumpingPortsModels, injectionFittingsModels } = pumpingPortStyleModels.reduce(
    (result, item) => {
      if (item.model === 'EIF-EZ') {
        result.injectionFittingsModels.push(item)
      } else {
        result.pumpingPortsModels.push(item)
      }
      return result
    },
    { pumpingPortsModels: [], injectionFittingsModels: [] },
  )

  return {
    injectionResinResults: getInjectionResinResults(input, injectionResinModels),
    pasteOverEpoxyResults: getPasteOverEpoxyResults(input, pasteOverEpoxyModels),
    pumpingPortsResults: getPumpingPortsResults(input, pumpingPortsModels),
    injectionFittingsResults: getInjectionFittingsResults(input, injectionFittingsModels),
  }
}
